import { ref } from "vue";

export function getStatusByStatitics(
    latencia?: string,
    snrv?: string,
    snrh?: string,
    rxh?: string,
    rxv?: string
): string {
    // 1. Recopilar solo las métricas que tienen un valor válido (no undefined, null ni string vacío)
    const metrics = [latencia, snrv, snrh, rxh, rxv].filter(Boolean);

    // Si no llegó ninguna métrica, devolvemos el estado por defecto
    if (metrics.length === 0) return 'DOWN';

    // 2. Prioridad de estados (de más crítico a menos crítico)
    if (metrics.includes('ALARM')) return 'ALARM';
    if (metrics.includes('DOWN')) return 'DOWN';
    if (metrics.includes('ALERT')) return 'ALERT';

    // 3. Si todas las métricas presentes son 'OK', el estado global es 'OK'
    if (metrics.every(status => status === 'OK')) return 'OK';

    return 'DOWN';
}


export function getStatusByLatency(latency: number) {
    let statusxlatency = 'DOWNdefault';

    if (latency > 0 && latency <= 100) statusxlatency = 'OK';
    if (latency > 100 && latency <= 500) statusxlatency = 'ALERT';
    if (latency > 500) statusxlatency = 'ALARM';
    if (latency == -1) statusxlatency = 'DOWN';

    return statusxlatency
}

export function getStatusBySNR(snr: number) {
    let peso = 'DOWNdefault';

    if (snr > 20) peso = 'OK';
    if (snr <= 20 && snr >= 16) peso = 'ALERT';
    if (snr < 16) peso = 'ALARM';

    return peso
}

export function getStatusByRXLVL(rxlvl: number) {
    let peso = 'DOWNdefault';

    if (rxlvl > -70) peso = 'OK';
    if (rxlvl <= -70 && rxlvl >= -80) peso = 'ALERT';
    if (rxlvl < -80) peso = 'ALARM';

    return peso
}


export async function getFinalStatusByStatitics(allFinalStatiticsItems: any) {
    const allFinalStatusItems = ref<any>({})

    Object.entries(allFinalStatiticsItems).forEach(([ip, item]: any, index: number) => {
        const statusItem = getStatusByStatitics(item.latencia, item.snrv, item.snrh, item.rxlvlh, item.rxlvlv);
        allFinalStatusItems.value[ip] = {
            status: statusItem,
            fecha: item.fecha,
            latencia: item.latenciaValue ?? 0,
            snrv: item.snrvValue ?? 0,
            snrh: item.snrhValue ?? 0,
            rxlvlh: item.rxlvlhValue ?? 0,
            rxlvlv: item.rxlvlvValue ?? 0,
            througtput: item.througtput ?? 0,
            temperatura: item.temperatura ?? 0,
            uptime: item.uptime ?? 0,
            perdida: item.perdida ?? 0,
            voltaje: item.voltaje ?? 0,
            costo: item.costo ?? 0,
            gps: item.gps ?? `[0,0,0]`,
        }
    });

    return allFinalStatusItems.value
}